'use es6';

import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UISection from 'UIComponents/section/UISection';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentLoading = () => {
  return /*#__PURE__*/_jsx(UISection, {
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 128
    })
  });
};
export default ContentLoading;